import { useTranslation } from 'react-i18next'
import { type NavigateOptions } from 'react-router-dom'

import { SuggestedRow } from '../SuggestedRow/SuggestedRow'

import { OpportunityCardSkeleton } from '@percent/workplace-giving/common/components/OpportunityCard/OpportunityCardSkeleton'
import { OpportunityCard } from '@percent/workplace-giving/common/components/OpportunityCard/OpportunityCard'
import { useSuggestedOpportunitiesRow } from './useSuggestedOpportunitiesRow'
import { useAnalytics } from '@percent/workplace-giving/common/hooks/useAnalytics/useAnalytics'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'

type SuggestedOpportunitiesRowProps = Readonly<{
  sectionTitle?: string
  seeAllNavigateOptions?: NavigateOptions
}>

export function SuggestedOpportunitiesRow({ sectionTitle, seeAllNavigateOptions }: SuggestedOpportunitiesRowProps) {
  const { t } = useTranslation()
  const { opportunities, isLoading, skeletonData } = useSuggestedOpportunitiesRow()
  const { track } = useAnalytics()

  const title = sectionTitle || t('workplace_giving.volunteering.suggested.title')

  if (isLoading) {
    return (
      <SuggestedRow
        title={title}
        testId="suggested-opportunities-row-skeleton"
        items={skeletonData}
        keyExtractor={key => key}
        renderItem={() => <OpportunityCardSkeleton />}
      />
    )
  }

  if (opportunities.length === 0) {
    return null
  }

  return (
    <SuggestedRow
      title={title}
      testId="suggested-opportunities-row"
      seeAllHref={AppRoute.VOLUNTEERING}
      seeAllNavigateOptions={seeAllNavigateOptions}
      items={opportunities}
      keyExtractor={o => o.id}
      renderItem={o => (
        <OpportunityCard
          key={o.id}
          opportunity={o}
          track={() => {
            track({
              event: 'Volunteering Opportunity Display Suggested',
              properties: {
                origin: 'New Home Suggested Opportunities',
                opportunityType: o.type,
                opportunityLocationType: o.location.type
              }
            })
          }}
        />
      )}
    />
  )
}
